import React, { useRef, useState, useEffect } from 'react'
import PureTitle from '../PureTitle'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import RadioButtonGroup from 'srcReact/components/common2/RadioButtonGroup'
import parentStyles from '../../styles.module.scss'
import Button from 'srcReact/components/common2/Button'
import LocationTextBox from 'srcReact/components/common2/LocationTextBox'
import { isEmpty, isValidLink } from 'srcReact/helpers/validator'
import { commonActions, GoogleMap } from 'srcReact/components'
import Label from 'srcReact/components/common2/Label'
import Input from 'srcReact/components/common2/Input'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import { useDispatch, useSelector } from 'react-redux'
import { isNum } from 'srcReact/helpers/utils'
import { getIdExternalApiAuth } from 'srcReact/helpers/userHelper'
import { mixrActions } from 'srcReact/Mixr/actions'
import Spinner from 'srcReact/components/common2/Spinner'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import JoinInLink from './JoinInLink'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'
export default function MixrVenue({
  editMode,
  showNextSection,
  hideNextButton,
  openEditMixrPopup,
  setDataToUpdateForRecMixr,
  previewEditMode
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedVenueTypeId, setSelectedVenueTypeId] = useState('in_person')
  const [locationRef, setLocationRef] = useState(null)
  const [joinInLinkRef, setJoinInLinkRef] = useState(null)
  const [valueChanged, setValueChanged] = useState(false)
  const [submitButtonAction, setSubmitButtonAction] = useState('')

  const {
    common: { isNative, timezone },
    login: { user: loggedInUser },
    mixr: {
      mixr: {
        id: mixrId,
        location: mixrLocation,
        //  attendance_limits,
        join_in_link,
        additional_information,
        attending_type,
        recurrence,
        virtual_meeting_provider
      },
      editLoading,
      editSuccess
    }
  } = useSelector((state) => state)
  const [originalMeetingProvider, setOriginalMeetingProvider] = useState('')
  const [meetingProvider, setMeetingProvider] = useState(virtual_meeting_provider || 'none')
  const [location, setLocation] = useState({
    value: '',
    placeholder: t('event.create.venue.locationPlaceholder'),
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const [joinLink, setJoinLink] = useState({
    value: '',
    placeholder: t('event.create.venue.joinLinkPlaceholder'),
    hasError: false,
    errorMessage: '',
    isRequired: false
  })
  const [additionalInfo, setAdditionalInfo] = useState({
    value: '',
    placeholder: t('event.create.venue.additionalInfoPlaceholder'),
    hasError: false,
    errorMessage: '',
    isRequired: false
  })

  const venueTypes = [
    { value: 'in_person', label: t('event.create.venue.venueInPerson') },
    { value: 'virtual', label: t('event.create.venue.venueVirtual') },
    { value: 'both', label: t('event.create.venue.venueBoth') }
  ]

  useEffect(() => {
    if (virtual_meeting_provider) {
      setOriginalMeetingProvider(virtual_meeting_provider)
      setMeetingProvider(virtual_meeting_provider)
    }
  }, [virtual_meeting_provider])

  useEffect(() => {
    if (mixrLocation) {
      setLocation({ ...location, value: mixrLocation })
    }
  }, [mixrLocation])
  useEffect(() => {
    if ((editMode || previewEditMode) && attending_type) {
      setSelectedVenueTypeId(attending_type)
    }
  }, [attending_type])

  useEffect(() => {
    if (editMode && editSuccess) {
      setValueChanged(false)
    }
  }, [editSuccess])

  useEffect(() => {
    if (editMode || previewEditMode) {
      setJoinLink({
        ...joinLink,
        value: join_in_link
      })
    }
  }, [join_in_link])
  useEffect(() => {
    if (editMode || previewEditMode) {
      setAdditionalInfo({
        ...additionalInfo,
        value: additional_information
      })
    }
  }, [additional_information])

  useEffect(() => {
    if (mixrLocation && timezone && timezone.value) {
      dispatch(mixrActions.setMixrData([{ key: 'location', value: { ...mixrLocation, timezone: timezone.value } }]))
    }
  }, [timezone])

  const handleVenueTypeChange = (e) => {
    setValueChanged(true)
    const value = e.target.value
    setSelectedVenueTypeId(value)

    if (!editMode) {
      dispatch(
        mixrActions.setMixrData([
          { key: 'attending_type', value: value },
          { key: 'virtual_meeting_provider', value: meetingProvider }
        ])
      )
    }
  }

  const handleNext = () => {
    const organizationId = getCurrentOrgId()
    dispatch(integrationActions.getActiveIntegrations(organizationId, 'virtual_meeting'))
    setTimeout(() => {
      if (validate()) {
        showNextSection()
      }
    }, 1500)
  }

  const handleSelectLocationBlur = (selectedLocation) => {
    if (!selectedLocation) {
      setLocation({
        ...location,
        value: selectedLocation,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.location`) })
      })
    }
  }

  const handleSelectLocation = (selectedLocation) => {
    setValueChanged(true)
    setLocation({
      ...location,
      value: selectedLocation,
      hasError: false,
      errorMessage: ''
    })

    dispatch(mixrActions.setMixrData([{ key: 'location', value: selectedLocation }]))
    dispatch(commonActions.getTimezoneByLatLong(selectedLocation.latitude, selectedLocation.longitude))
  }

  const handleClear = () => {
    setValueChanged(true)
    setLocation({
      ...location,
      value: null,
      hasError: true,
      errorMessage: t('error.required', { field: t(`formlabel.location`) })
    })
    dispatch(commonActions.clearTimezone())
  }
  const handlejoinLinkChange = (e) => {
    setValueChanged(true)
    setJoinLink({
      ...joinLink,
      hasError: false,
      errorMessage: '',
      value: e.target.value
    })
  }

  const handleJoinLinkBlur = (e) => {
    const value = e.target.value
    let valid = true
    let error = ''
    if (meetingProvider === 'none') {
      if (!value) {
        valid = false
        error = t('event.create.clientErrors.joinLinkRequired')
      }
      if (!isValidLink(value)) {
        valid = false
        error = t('event.create.clientErrors.invalidLink')
      }
    }

    setJoinLink({
      ...joinLink,
      value: value,
      hasError: !valid,
      errorMessage: error
    })
    if (!editMode && valid) {
      dispatch(mixrActions.setMixrData([{ key: 'join_in_link', value: value }]))
    }
  }

  const handleAdditionalInfoChange = (e) => {
    setValueChanged(true)
    const value = e.target.value
    setAdditionalInfo({
      ...additionalInfo,
      hasError: false,
      errorMessage: '',
      value: value
    })
  }
  const handleAdditionalInfoBlur = (e) => {
    const value = e.target.value
    if (!editMode) {
      dispatch(mixrActions.setMixrData([{ key: 'additional_information', value: value }]))
    }
  }

  const validate = () => {
    if (selectedVenueTypeId !== 'virtual' && isEmpty(location.value)) {
      //selectedVenueTypeId !== 'virtual' &&
      //} && locationRef.current) {
      //locationRef.current?.focus()
      setLocation({
        ...location,
        hasError: true,
        errorMessage: t('error.required', { field: t(`formlabel.location`) })
      })
      return false
    }

    if (selectedVenueTypeId !== 'in_person' && meetingProvider === 'none' && joinInLinkRef?.current) {
      let valid = true
      let error = ''
      if (isEmpty(joinLink.value)) {
        valid = false
        error = t('event.create.clientErrors.joinLinkRequired')
      } else if (!isValidLink(joinLink.value)) {
        valid = false
        error = t('event.create.clientErrors.invalidLink')
      }
      if (!valid) {
        joinInLinkRef.current?.focus()
        setJoinLink({
          ...joinLink,
          hasError: !valid,
          errorMessage: error
        })
        return false
      }
    }

    return true
  }

  const handleCancel = () => {
    setValueChanged(false)
    setSelectedVenueTypeId(attending_type)
    setLocation({ ...location, value: mixrLocation })
    setAdditionalInfo({
      ...additionalInfo,
      value: additional_information
    })

    // setSelectedAttendanceLimit(
    //   attendance_limits && attendance_limits.length > 0
    //     ? {
    //         value: 1,
    //         label: t('global.yes')
    //       }
    //     : {
    //         value: 0,
    //         label: t('event.create.none')
    //       }
    // )

    // if (attendance_limits) {
    //   setMixrAttendanceLimit(JSON.parse(JSON.stringify(attendance_limits)))
    // }
    // if (
    //   attendance_limits &&
    //   attendance_limits.length > 0 &&
    //   (attending_type === 'in_person' || attending_type === 'both')
    // ) {
    //   setInPersonLimit({ ...inPersonLimit, value: attendance_limits[0].limit })
    // }
    // if (
    //   attendance_limits &&
    //   attendance_limits.length > 0 &&
    //   (attending_type === 'virtual' || attending_type === 'both')
    // ) {
    //   setVirtualLimit({ ...virtualLimit, value: attendance_limits[1].limit })
    // }
    if (attending_type === 'virtual') {
      setJoinLink({
        ...joinLink,
        value: join_in_link
      })
    }
  }

  const handleVideoOptionChange = (option) => {
    setValueChanged(true)
    setMeetingProvider(option)
    setJoinLink({
      ...joinLink,
      hasError: false,
      errorMessage: ''
    })
    if (!editMode) {
      dispatch(mixrActions.setMixrData([{ key: 'virtual_meeting_provider', value: option }]))
    }
  }

  const handleSave = () => {
    const organizationId = getCurrentOrgId()
    dispatch(integrationActions.getActiveIntegrations(organizationId, 'virtual_meeting'))
    setTimeout(() => {
      if (validate()) {
        // let updatedAttendanceLimit = []

        // if (mixrAttendanceLimit.length > 0) {
        //   updatedAttendanceLimit = mixrAttendanceLimit.filter((x) => {
        //     if (x.limit !== -1 && x.limit != '') {
        //       if (
        //         (selectedVenueTypeId === 'in_person' && x.type === 'in_person') ||
        //         (selectedVenueTypeId === 'virtual' && x.type === 'virtual') ||
        //         selectedVenueTypeId === 'both'
        //       ) {
        //         return x
        //       }
        //     }
        //   })
        // }

        let meetingProviderUpdate = 'nochange'

        if (originalMeetingProvider !== meetingProvider) {
          if (originalMeetingProvider === 'none') {
            meetingProviderUpdate = 'newmeeting'
          } else if (meetingProvider === 'none') {
            meetingProviderUpdate = 'remove'
          } else {
            meetingProviderUpdate = 'newmeeting'
          }
        }

        let data = {
          ...(selectedVenueTypeId !== 'virtual' && { location: location.value }),
          ...(selectedVenueTypeId === 'virtual' && {
            timezone_id: mixrLocation.timezone?.timezone_id || mixrLocation.timezone?.id
          }), // location is mandatory for in-person or both // timezone_id is mandatory for virtual
          attending_type: selectedVenueTypeId,
          // ...(selectedAttendanceLimit.value === 1 && updatedAttendanceLimit.length > 0
          //   ? { attendance_limits: updatedAttendanceLimit }
          //   : { attendance_limits: '' }),
          ...((selectedVenueTypeId === 'virtual' || selectedVenueTypeId === 'both') && {
            id_external_api_auth: getIdExternalApiAuth() || 0,
            join_in_link: joinLink.value,
            virtual_meeting_provider: meetingProvider,
            virtual_meeting_provider_update: meetingProviderUpdate
          }),
          additional_information: additionalInfo.value
        }
        if (recurrence && recurrence.type !== 'none' && recurrence.is_parent_event !== 1) {
          openEditMixrPopup()
          setDataToUpdateForRecMixr(data)
        } else {
          dispatch(mixrActions.editMixr(mixrId, data))
        }
      }
    }, 1500)
  }

  return (
    <React.Fragment>
      <PureTitle title={t('event.create.venue.venueTypeTitle')} isRequired={true} />
      <RadioButtonGroup
        label={t('event.create.mixrType')}
        items={venueTypes}
        selectedItemValue={selectedVenueTypeId}
        onChange={handleVenueTypeChange}
        radioContainerCSS={styles.radioContainerCSS}
        radioButtonCss={styles.radioButtonCss}
        labelCSS={parentStyles.labelCSS}
      />
      {selectedVenueTypeId !== 'virtual' && (
        <React.Fragment>
          {!isEmpty(location.value) && (
            <div className={styles.googleMap}>
              <div className={styles.googleMapSpace} />
              <GoogleMap
                className={`${styles.map} ${parentStyles.full}`}
                apiKey={config.googleFrontKey}
                lat={location.value.latitude}
                lng={location.value.longitude}
                zoom={15}
                title={location.value.formatted_address}
              />
            </div>
          )}
          <div className={styles.locationContainer}>
            <Label ariaLabel={t('event.create.venue.location')}>{t('event.create.venue.location')}</Label>
            <LocationTextBox
              value={location}
              ariaLabel={'event.create.venue.location'}
              placeholder={t('event.create.venue.locationPlaceholder')}
              locationContainerCSS={`${location} ${parentStyles.full}`}
              setRef={setLocationRef}
              handleSelectLocation={handleSelectLocation}
              handleSelectLocationBlur={handleSelectLocationBlur}
              handleClear={handleClear}
              menuPortalTarget={true}
            />
            {location && location.hasError && (
              <ErrorMessage text={location.errorMessage} className={parentStyles.error} />
            )}
          </div>
        </React.Fragment>
      )}
      {selectedVenueTypeId !== 'in_person' && (
        <React.Fragment>
          <div className={styles.joinInLinkContainer}>
            <Label ariaLabel={t('event.create.venue.joinLink')}>{t('event.create.venue.joinLink')}</Label>
            <JoinInLink
              setJoinInLinkRef={setJoinInLinkRef}
              joinLink={joinLink}
              handlejoinLinkChange={handlejoinLinkChange}
              handleJoinLinkBlur={handleJoinLinkBlur}
              handleVideoOptionChange={handleVideoOptionChange}
              selected={meetingProvider}
              editMode={editMode}
            />
            {joinLink && joinLink.hasError && (
              <ErrorMessage text={joinLink.errorMessage} className={parentStyles.error} />
            )}
          </div>
        </React.Fragment>
      )}
      <div className={styles.additionalInfoContainer}>
        <Label ariaLabel={t('event.create.venue.additionlInfo')}>{t('event.create.venue.additionlInfo')}</Label>
        <Input
          value={additionalInfo.value}
          placeholder={t('event.create.venue.additionalInfoPlaceholder')}
          onChange={handleAdditionalInfoChange}
          onBlur={handleAdditionalInfoBlur}
        />
      </div>

      {editMode ? (
        valueChanged ? (
          <div className={parentStyles.buttons}>
            <Button style='secondary' text={t('global.cancel')} handleClick={handleCancel} />
            <Button
              type='button'
              handleClick={handleSave}
              text={
                editLoading && recurrence && (recurrence.type === 'none' || recurrence.is_parent_event === 1) ? (
                  <Spinner isWhite={true} />
                ) : (
                  t('global.save')
                )
              }
            />
          </div>
        ) : null
      ) : !hideNextButton ? (
        <div className={parentStyles.buttons}>
          <Button text={t('global.btnNext')} handleClick={handleNext} />
        </div>
      ) : null}
    </React.Fragment>
  )
}
